var map = {
	"./Payment_support.jpg": "f960",
	"./b-kefu.png": "5a2a",
	"./b-liwu.png": "4075",
	"./b-tuikuan.png": "8b0f",
	"./b-wuliu.png": "44ef",
	"./bag.png": "caea",
	"./balance.png": "0d11",
	"./categories/camera.png": "93b2",
	"./coupon-bg.png": "da09",
	"./coupon.png": "2b7e",
	"./coupon_bg.png": "e03c",
	"./coupon_type.png": "af9a",
	"./emjoy.png": "5897",
	"./famous.png": "bd32",
	"./fashion.png": "611f",
	"./fashionTop.png": "f223",
	"./floor_title.png": "31f2",
	"./goods/coupon.png": "2e39",
	"./goods/discount_bg.png": "028c",
	"./goods/goods_detail_bg.png": "43a7",
	"./goods/qrcode.png": "5d2e",
	"./goods/split.png": "a31b",
	"./index-1.png": "dcbf",
	"./index-2.png": "e1b5",
	"./index-3.png": "bdc4",
	"./index-4.png": "3aa1",
	"./index-5.png": "fcad",
	"./index-6.png": "e84d",
	"./index-coupon.png": "0842",
	"./index/404.png": "0b98",
	"./index/closed.png": "cd89",
	"./kefupng.png": "7e62",
	"./limited_time.png": "ab91",
	"./list_bj.png": "34ac",
	"./logo.png": "9d64",
	"./member-empty.png": "fb77",
	"./midImg.png": "f668",
	"./new_products.png": "038a",
	"./payment/CreditCard.png": "bd8e",
	"./payment/CreditCard2.png": "780f",
	"./payment/address-border.png": "d0391",
	"./payment/paypalPAY.png": "8f2f",
	"./point.png": "4fc8",
	"./product.png": "52bb",
	"./sale_num.png": "eee1",
	"./shop-defaultImg.png": "b5c9",
	"./shop_index.png": "06c8",
	"./superposition.png": "db0d",
	"./upload.png": "894f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";